/* src/app/private/components/client-center/create-center/create-center.component.scss */
/*# sourceMappingURL=create-center.component.css.map */
